import React, { useEffect, useState } from 'react';
import MulSelector from './MultipleSelector';
import { useIntl } from 'umi';

export default function SelectContext(props: any) {
  const {
    value: defaultValue,
    onConfirm,
    options,
    showIcon = false,
    // Device 文字替换为 Platform
    // btnName = 'dbi_device',
    btnName = 'dbi_platform',
    tips,
    AWidth,
  } = props;
  const { formatMessage } = useIntl();
  const [deviceVal, setDeviceVal] = useState(defaultValue || []);
  const [optionsNew, setOptionsNew] = useState(options);

  useEffect(() => {
    setDeviceVal(defaultValue || []);
  }, [defaultValue]);

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  useEffect(() => {
    if (showIcon) {
      const optionsIcons = options?.map((item: any) => {
        return {
          ...(item || {}),
          text: (
            <span className=".dbi-select-button">
              {item?.icon && (
                <img
                  style={{ width: 16, verticalAlign: 'middle', marginRight: 4 }}
                  src={item?.icon}
                />
              )}
              {item?.text}
            </span>
          ),
        };
      });
      setOptionsNew(optionsIcons);
    } else {
      setOptionsNew(options);
    }
  }, [JSON.stringify(options), showIcon]);

  return (
    <MulSelector
      hasAllCheck
      className="select-device"
      value={deviceVal}
      options={optionsNew}
      buttonName={typeof btnName === 'string' ? formatMessage({ id: btnName }) : ''}
      onChange={handleChange}
      tips={tips}
      AWidth={AWidth}
    />
  );
}
